import 'should'
import Player from '../src/Player'
import {Card, Color, Icon} from '../src/cards/Card'
import WF from '../src/cards/WheatField'

describe('Card', () => {
	it('should have the correct name', function(done) {
		let card = new WF

		card.name.should.equal('Wheat Field')
		done()
	})

	describe('Color', () => {
		it('should have a color', function (done) {
			let card1 = new Card({
				color: 'red'
			})

			let card2 = new Card({
				color: Color.RED
			})

			card1.color.should.equal(card2.color)
			card2.color.key.should.equal('RED')
			done()
		})

		it('should have a valid color', function (done) {
			let createBadCard = () => {
				new Card({
					color: 'magenta'
				})
			}

			createBadCard.should.throw(TypeError)

			done()
		})
	})

	describe('Icon', () => {
		it('should have a icon', function (done) {
			let card1 = new Card({
				icon: 'gear'
			})

			let card2 = new Card({
				icon: Icon.GEAR
			})

			card1.icon.should.equal(card2.icon)
			card1.icon.key.should.equal('GEAR')
			done()
		})

		it('should have a valid icon', function (done) {
			let createBadCard = () => {
				new Card({
					color: 'dog'
				})
			}

			createBadCard.should.throw(TypeError)

			done()
		})
	})

	it('should activate the card', function (done) {
		let hit = false
		let player = new Player({})
		let card = new Card({
			color: 'green',
			activation: 4,
			owner: player,
		})

		card.activate = () => {
			hit = true
		}

		card.rolled(1, player)
		hit.should.be.false()

		card.rolled(4)
		hit.should.be.false()

		card.rolled(4, player)
		hit.should.be.true()

		done()
	})

	it('should have correct stats', function (done) {
		let stats = {
			"icon": "wheat",
			"cost": 1,
			"color": "purple",
			"activation": [1, 5],
			"description": "Get 1 coin from bank",
		}

		let card = new Card(stats)

		card.icon.key.should.equal(stats.icon.toUpperCase())
		card.color.key.should.equal(stats.color.toUpperCase())
		card.cost.should.equal(stats.cost)
		card.activation.should.equal(stats.activation)
		card.description.should.equal(stats.description)
		done()
	})
})
